import { render, staticRenderFns } from "./carHold.vue?vue&type=template&id=591220e4&scoped=true"
import script from "./carHold.vue?vue&type=script&lang=js"
export * from "./carHold.vue?vue&type=script&lang=js"
import style0 from "./carHold.vue?vue&type=style&index=0&id=591220e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591220e4",
  null
  
)

export default component.exports